module.exports = __webpack_public_path__ + "static/media/screenshot(41).ff1cbd5d.jpg";